import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AddStringModalComponent } from 'app/modules/well-header-information/pages/wells/wellbore/add-string-modal/add-string-modal.component';
import { EditWellboreModalComponent } from 'app/modules/well-header-information/pages/wells/wellbore/edit-wellbore-modal/edit-wellbore-modal.component';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { WellboreClass } from 'app/modules/well-header-information/model/wells.model';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';

@Component({
  selector: 'app-wellbore',
  templateUrl: './wellbore.component.html',
  standalone: true,
  imports: [
    NgClass
  ],
  styleUrls: ['./wellbore.component.scss']
})
export class WellboreComponent {
  public wellbore: WellboreClass;

  constructor(
    private route: ActivatedRoute,
    private wellHeaderService: WellHeaderInfoService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      let wellboreId = params.get('wellboreId');
      this.getWellbore(wellboreId)
    });
  }

  getWellbore(id) {
    this.wellHeaderService.getWellbore(id).subscribe((res) => {
      this.wellbore = {
        wellboreId: res.data.id,
        wellId: res.data.wellId,
        name: res.data.wellboreShortName,
        longName: res.data.wellboreLongName,
        status: res.data.wellboreStatus,
        rigName: res.data.rigName,
        spudDate: res.data.spudDate,
        thfRkbElevation: res.data.thfRkbElevation,
        completionDate: res.data.completionDate,
        createdDate: res.data.inputDate,
        level: 'Wellbore'
      };
    })
  }


  addStringModal(wellboreDetails: any) {
    const dialogRef = this.dialog.open(AddStringModalComponent, {
      data: {
        wellId: wellboreDetails.wellId,
        wellboreId: wellboreDetails.wellboreId
      },
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      if (isSuccess) {
        this.wellHeaderService.selectedWellPlatform$.subscribe(selectedPlatform => {
          this.wellHeaderService.getWellsTree(selectedPlatform.platformId).subscribe()
          this.wellHeaderService.updateParentsNode([this.wellbore.wellId, this.wellbore.wellboreId])
        })
      }
    });
  }


  editWellboreModal(wellboreData: any) {
    const dialogRef = this.dialog.open(EditWellboreModalComponent, {
      data: wellboreData,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      if (isSuccess) {
        this.getWellbore(wellboreData.wellboreId)
      }
    });
  }

  handleDateFormat(dateString: string, withTime: boolean = false){
    return handleFormatDate(dateString,withTime)
  }
}
